// extracted by mini-css-extract-plugin
module.exports = {"description":"SetPasswordModal_description__gthYb"};